import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { Box, Typography } from "@mui/material"

import { ImageSkuBlock } from "@components"
import { SkuInfoBlockWrap } from "../@components/Table/@components"
import { adminNewListedFormRowData, skuForm, brandForm } from "../@signals"

export default function AdminNewListedFormIACardsOptions() {
    const selectedIdx = useSignal(null)
    const initialSkuForm = useSignal(null)
    const initialBrandForm = useSignal(null)

    const handleClick = (idx, element) => {

        if (selectedIdx.value === null) {
            initialSkuForm.value = skuForm.value
            initialBrandForm.value = brandForm.value
        }

        if (selectedIdx.value === idx) {
            selectedIdx.value = null
            skuForm.value = initialSkuForm.value
            brandForm.value = initialBrandForm.value
        } else {
            selectedIdx.value = idx
            skuForm.value = element.skuID
            brandForm.value = element.brandID
        }

    }

    const styles = {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'rgb(255, 255, 255)',
        boxShadow: 'rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px',
        borderRadius: '12px',
        padding: 2,
        "&:hover": { cursor: 'pointer', backgroundColor: 'primary.light' },
        mb: 3,
        width: '100%'
    }

    const selectedStyles = {
        ...styles,
         boxShadow: `1px 10px 20px 1px #9dd4f7`
    }

    return <Box > 
        <Typography sx={{ mb: 3 }}>Options Suggested By IA</Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            {adminNewListedFormRowData.value.IAOptionsDataList.map((element, idx) => 
                <Box key={idx} sx={selectedIdx.value === idx ? selectedStyles : styles} onClick={() => handleClick(idx, element)}>
                    <ImageSkuBlock 
                        skuID={element?.skuID}
                        skuName={element.skuName} 
                        contentProps={{ sx: {margin: '', marginRight: 3} }} 
                    />
                    <SkuInfoBlockWrap 
                        sku={element.skuName} 
                        category={element.category} 
                        brand={element.brand} 
                        maxWidthEllipsis={600}
                    />
                </Box>
            )}
        </Box>
    </Box> 
}